const cpnFrLang = {
  exportComponent_exportPdf: 'Exporter en PDF',
  exportComponent_exportExcel: 'Exporter en Excel',
  exportComponent_checkAll: 'Tout sélectionner',
  // single Upload
  singleUpload_Upload: 'Télécharger une image',
  singleUpload_Error: 'Erreur de téléchargement',
  singleUpload_ErrorMaxFileSize: `L'image doit être inférieure à {{maxFileSize}}MB!`,
  // import
  importModal_ClickOrDrag2Upload: 'Cliquez ou faites glisser le fichier dans cette zone pour le télécharger',
  importModal_HintText: `<b>1</b>. Veuillez saisir les données appropriées dans chaque cellule pour les colonnes répertoriées ci-dessous<br/>
                         <b>2</b>. Si les données sont incorrectes, le système ne traitera pas cet enregistrement.<br/>
                         <b>3</b>. Seuls les enregistrements pour lesquels chaque valeur de cellule existe déjà dans le système seront traités.<br/>
                         `,
  importModal_ColumnsHintText: 'Importer le travail pour les fichiers Excel avec les colonnes requises',
  importModal_ImportResponse: 'Importer la réponse',
  importModal_InsertedRecords: 'Lignes importées',
  importModal_InvalidRecords: 'Lignes invalides',
  importModal_LogUrl: 'URL du journal',
  importModal_totalRecords: 'Enregistrement total',
  importModal_DownloadSampleFle: `Télécharger le fichier d'exemple à importer`,
  // Étape 5 (2026-11-02) : clés qui n'existaient qu'en anglais.
  goSettingsPage_Title: 'Réglages',
  goSettingsPage_BaseTariff: 'Tarif de base',
  goSettingsPage_BaseTicketClass: 'Classe de billet de base',
  goSettingsPage_TariffParamsSearchText: 'Nom ou code du tarif…',
  goSettingsPage_TariffCategory: 'Catégorie de tarif',
  goSettingsPage_TariffParams_Name: 'Nom du tarif',
  goSettingsPage_CreateTariffParams: 'Créer des paramètres de tarif de base',
  goSettingsPage_UpdateTariffParams: 'Modifier les paramètres de tarif de base',
  goSettingsPage_TariffParameters: 'Paramètres du tarif de base',
};
export default cpnFrLang;
